import { render } from "./RegisterVerify.vue?vue&type=template&id=069e80b6"
import script from "./RegisterVerify.vue?vue&type=script&lang=js"
export * from "./RegisterVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__